import { GridColumns } from '../../../core/components/grid/GridColumns.js';
import { GridRows } from '../../../core/components/grid/GridRows.js';
import {
  getVerticalNumTicks,
  getHorizontalNumTicks,
} from '../../../core/utils/ticks.js';
import type { AnyScale } from '../../types/scales.js';
import { isBandScale } from '../../utils/detect-scale.js';

export type GridProps = {
  width: number;
  height: number;
  xScale: AnyScale;
  yScale: AnyScale;
  highlightZeroLine?: {
    horizontal?: boolean;
    vertical?: boolean;
  };
  xTicks?: number[];
  yTicks?: number[];
  xCategoryOffset?: number;
  yCategoryOffset?: number;
};
const DEFAULTS = {
  HIGHLIGHT_ZERO_LINE: {
    horizontal: true,
    vertical: true,
  },
};
/**
 * The grid columns component for charts
 */
export function Grid({
  width,
  height,
  xScale,
  yScale,
  highlightZeroLine = DEFAULTS.HIGHLIGHT_ZERO_LINE,
  xTicks,
  yTicks,
  xCategoryOffset,
  yCategoryOffset,
}: GridProps) {
  const numTicksRows = getVerticalNumTicks(height);
  const autoNumTicks = getHorizontalNumTicks(width);

  const xNumTicks =
    xCategoryOffset !== undefined && isBandScale(xScale)
      ? xScale.domain().length
      : autoNumTicks;

  const yNumTicks =
    yCategoryOffset !== undefined && isBandScale(yScale)
      ? yScale.domain().length
      : numTicksRows;

  return (
    <g>
      <GridColumns
        height={height}
        scale={xScale}
        numTicks={xNumTicks}
        highlightZeroLine={highlightZeroLine.vertical}
        ticks={xTicks}
        offset={xCategoryOffset}
      />
      <GridRows
        width={width}
        scale={yScale}
        numTicks={yNumTicks}
        highlightZeroLine={highlightZeroLine.horizontal}
        ticks={yTicks}
        offset={yCategoryOffset}
      />
    </g>
  );
}
